
import {Component, Prop, Watch} from "vue-property-decorator";
import QrCodeReader from "@/components/QrCodeReader.vue";
import {Getter} from "vuex-class";
import PinCode from "@/components/relays/PinCode.vue";
import SimpleDialog from "@/components/SimpleDialog.vue";
import KeyReturningDate from "@/components/keys/actions/KeyReturningDate.vue";
import OverPriceSms from "@/components/OverPriceSms.vue";
import {regex} from "@/utils/formRules";
import { TranslateResult } from "vue-i18n";
import { CONTEXT_TYPES, IContext } from "@/store/modules/context";
import { mixins } from "vue-class-component";
import DocumentMixin from "@/mixins/DocumentMixin.vue";
import MylobyAutocomplete from "@/components/generic/autocomplete.vue";
import KeyAddGuestDialog from "@/components/keys/guests/KeyAddGuestDialog.vue";

enum BUTTON_STYLE {
  icon = "icon",
  mobile = "mobile",
  desktop = "desktop",
}

@Component({
    components: {
        KeyAddGuestDialog,
        MylobyAutocomplete,
        QrCodeReader,
        PinCode,
        SimpleDialog,
        KeyReturningDate,
        OverPriceSms,
    },
})
export default class RelayGiveKeyToGuest extends mixins(DocumentMixin) {

  get currentUserBooking(): string|undefined {
        return this.currentKey?.currentBooking?.User?.displayName;
    }

    get currentRelay(): any {
        return this.currentKey?.currentLocation?.Box?.Building?.Relays?.[0];
    }

    get allowMail(): boolean {
        return !!this.selectedGuest?.email && !regex.validPhoneNumber.test(this.selectedGuest.email);
    }

    get allowPhone(): boolean {
        return !!this.selectedGuest?.phone;
    }

    get defaultNotificationType(): string {
        if (this.allowMail && !this.allowPhone) {
            return "email";
        }
        if (!this.allowMail && this.allowPhone) {
            return "sms";
        }
        return null;
    }

    get editGuest(): boolean {
      return this.canDoInEnvCompany("MANAGE_KEY_GUESTS");
    }

    get canGive(): boolean {
      return this.isKeyInRelay && !this.isKeyInConnectedBox;
    }

    get canDrop(): boolean {
      return !this.isKeyInRelay && !this.isKeyInConnectedBox
        && !this.userHasKey && !this.isKeyInitialized
        && !this.isKeyUnarchived;
    }

    get isKeyInitialized(): boolean {
        return this.currentKey?.status === "CREATED";
    }

    get isKeyUnarchived(): boolean {
        return this.currentKey?.status === "UNARCHIVED";
    }

    get currentLocation() {
        return this.currentKey?.KeyLocation?.find((kL) => !kL.endDate);
    }

    get isKeyInConnectedBox(): boolean {
        return !!this.currentLocation?.Location?.Box?.ConnectedBox;
    }

    get userHasKey(): boolean {
        return this.currentKey?.KeyHolding?.find((kH) => !kH.endDate)?.userId === this.currentUser?.id;
    }

    get isKeyInRelay(): boolean {
        return this.currentKey?.status === "IN_RELAY";
    }

    get buttonAction(): any {
        return this.canDrop
            ? this.dropActionButton
            : this.withdrawActionButton;
    }

    get buttonIcon(): string {
        return this.canDrop
            ? "icon-picto_depot-agence"
            : "icon-picto_retrait-agence";
    }

    get buttonTitle(): string {
        return this.canDrop
            ? "dropB2B"
            : "give";
    }

    get isReferent(): boolean {
        const keyRelay = this.currentKey.Relays[0];
        // ne marche pas a cause de le pagination
        return this.userRelays?.some((relay) => relay.id === keyRelay?.id);
    }

    get displayMoveAllSubObjects(): boolean {
        return this.subObjectsWithSameStatus?.length > 0 && this.context?.type !== CONTEXT_TYPES.LOCATION;
    }

    // tslint:disable-next-line:no-empty
    @Prop({default: () => ({})})
    public currentKey: any;

    @Prop({default: () => ({})})
    public relay: any;

    @Prop({default: false})
    public disabled: boolean;

    @Prop({default: "icon"})
    public buttonStyle: BUTTON_STYLE;

    @Prop({default : false})
    public listView;

    public $refs!: {
      relayGiveKeySelectGuestAutocomplete: any,
    };

    @Getter private currentUser: any;
  @Getter private canDoInEnvCompany: (right: string) => boolean;
  @Getter private context: IContext|null;
    @Getter private isMobile: boolean;
    @Getter("users/relays") private userRelays: any[];


  private displayChooseHour: boolean = false;
    private handToHandDialog: boolean = false;
    private selectedGuest: any = null;
    private autoSelectedKeyGuest: number = null;
    private handToHandQrCode: string = null;
    private loadHandToHand: boolean = false;
    private displayQrCodeReader: boolean = false;
    private loadingQrCodeStreamer: boolean = false;
    private displayPinPad: boolean = false;
    private token: string = "";
    private relayId: number = null;
    private qrCodeReaderError: any = null;
    private estimatedEndDate: string = null;
    private droppingAction: boolean = false;
    private addGuestModal: boolean = false;
    private acceptOverPrice: boolean = false;
    private notificationType: string = "sms";
    private modalType: string = null;
    private bookingWarning?: TranslateResult = "";
    private loading: boolean = false;
    private subObjectsWithSameStatus: any[] = [];
    private moveAllSubObjects: boolean = false;
    private loadingWithdrawQuery: boolean = false;
    private canGuestChooseReturnHour: boolean = false;

    @Watch("currentKey", { immediate: true, deep: true })
    public  onCurrentKeyChanged(newValue: any, oldValue: any) {
      if (newValue && (newValue.id !== oldValue?.id)) {
          this.fetchRelayOptions();
        }
      }

    @Watch("selectedGuest", {immediate: true})
    public handlerSelectedGuest(): void {
        this.notificationType = this.defaultNotificationType || "sms";
    }

    private async fetchRelayOptions() {
        if (this.currentRelay) {
          this.canGuestChooseReturnHour = await this.$store.dispatch("options/readOptionValueByBuilding", {
            buildingId: this.currentRelay.buildingId || this.currentRelay.Building.id,
            optionTypeLabel: "canGuestChooseReturnHour",
          });
        }
    }

    private mounted(): void {
      if (this.currentKey) {
        this.fetchRelayOptions();
      }
    }

    private async getSubObjectsWithSameStatus(): Promise<any[]> {
        const subKeys = (await this.$store.dispatch("keys/getSubKeys", {
          id: this.currentKey.id,
        }))?.subKeys || [];
        return subKeys.filter((ck: any) => {
            let sameLocation: boolean;
            try {
                sameLocation = this.currentKey.KeyLocation[0].Location.Box.id === ck.KeyLocation[0].Location.Box.id;
            } catch (err) {
                sameLocation = false;
            }
            return (this.currentKey.status === ck.status) && (sameLocation || ck.status === "CREATED");
        });
    }

    private async selectGuestHandToHand(): Promise<any> {
        this.loadHandToHand = true;
        this.modalType = null;
        return this.$store.dispatch("keys/giveKeyToGuest", {
            keyId: this.currentKey?.id,
            sourceRelayId: this.relay.id,
            targetUserId: this.selectedGuest.id,
            notificationType: this.notificationType,
            acceptOverPrice: this.acceptOverPrice,
            fromModal: true,
            companyId: this.currentUser.companyId,
        }).then(async (qrCode: string) => {
            this.acceptOverPrice = false;
            if (qrCode) {
                this.handToHandQrCode = qrCode;
                this.$store.commit("alerts/displaySuccess", {
                    msg: this.$t("pin.guestReceivedPin"),
                });
            }
            // When we have context location, we should directly display the pin code modal
            if (this.context) {
                await this.readQRCode({
                  token: this.context.token,
                  moveAllSubObjects: this.moveAllSubObjects,
                });
            } else {
                this.displayQrCodeReader = true;
            }
        }).catch((error) => {
            switch (error?.response?.data?.message) {
                case "smsLimitReached":
                    this.acceptOverPrice = true;
                    this.modalType = "smsLimitReached";
                    break;
                case "smsOverpriceLimitReached":
                    this.acceptOverPrice = true;
                    this.modalType = "smsOverpriceLimitReached";
                    break;
                case "freemium":
                    this.$store.commit("alerts/displayError", {
                        msg: this.$i18n.t("invitation.freemium"),
                    });
                    break;
                default:
                    this.$store.commit("alerts/displayHttpError", { error });
                    break;
            }
            this.loadHandToHand = false;
        });
    }

    private openAddGuest(): void {
        this.addGuestModal = true;
    }

  private addedGuest(keyAccess: any): void {

    try {
      this.$store.dispatch("userGroups/getUsersInGroup", {
        id: keyAccess.userGroupId,
      }).then((rows) => {
        const user = rows.users?.[0];
        const group = user?.UsersGroup?.[0];
        if (group && group.type === "user") {
          // Here, we want to auto-select the user newly added (only if it is a solo user)
          this.autoSelectedKeyGuest = user;
          this.selectedGuest = user;
        } else if (this.$refs.relayGiveKeySelectGuestAutocomplete) {
          this.$refs.relayGiveKeySelectGuestAutocomplete.getFirstItems();
        }
        this.addGuestModal = false;
      });
    } catch (error) {
      // tslint:disable-next-line:no-console
      console.log(error);
    }
  }

    private closeDialog(): void {
        this.handToHandDialog = false;
        this.loadHandToHand = false;
        this.selectedGuest = null;
        this.autoSelectedKeyGuest = null;
        this.loading = false;
        this.closeDialogPin();
        this.resetQrCodeReader();
    }

    private closeDialogPin(): void {
        this.handToHandQrCode = null;
        this.displayPinPad = false;
    }

    private formatDate(date): string {
        return this.$options.filters.formatDateHour(date);
    }

    private makeWarningBooking(booking: any): void {
        const startDate: string = this.formatDate(booking.startDate);
        if (booking?.user) {
            this.bookingWarning = this.$i18n.t("key.warningBookingUser", {
                    startDate,
                    userName: booking.groupName
                        || booking.user.displayName || booking.user.email,
                });
        } else {
            this.bookingWarning = this.$i18n.t("key.warningBooking", {
                    startDate,
            });
        }
    }

    private async checkNextTemporalInvitation(): Promise<void> {
        this.bookingWarning = "";
        this.subObjectsWithSameStatus = await this.getSubObjectsWithSameStatus();
        const getKeyAccessById = (id) => this.$store.dispatch("keys/getKeyAccessById", {
          id,
        }).catch();
        const checkPromises = [
          getKeyAccessById(this.currentKey.id),
          ...this.subObjectsWithSameStatus.map((subKey: any) => getKeyAccessById(subKey.id)),
        ];
        return Promise.all(checkPromises).then((bookings: any[]) => {
            const firstBooking = bookings.find((booking: any) => !!booking?.keyAccess);
            if (firstBooking?.keyAccess) {
              this.makeWarningBooking(firstBooking.keyAccess);
            }
        });
    }

    private async withdrawActionButton() {
        this.loading = true;
        // Check current invitations on key
        await this.checkNextTemporalInvitation();
        this.loading = false;
        this.droppingAction = false;
        if (this.canGuestChooseReturnHour) {
            this.displayChooseHour = true;
        } else {
            this.handToHandDialog = true;
        }
    }

    private dropActionButton(): void {
        this.droppingAction = true;
        this.displayQrCodeReader = true;
    }

    private resetQrCodeReader(): void {
        this.qrCodeReaderError = null;
        this.displayQrCodeReader = false;
        this.loadingQrCodeStreamer = false;
    }

    private validateTime(value): void {
        this.estimatedEndDate = (new Date(value)).toISOString().substr(0, 19);
        this.displayChooseHour = false;
        this.handToHandDialog = true;
    }

    private readQRCode(params: {token: string, moveAllSubObjects?: boolean}): Promise<any> {
        const {token} = params;
        this.token = token;
        this.qrCodeReaderError = null;
        this.loadingQrCodeStreamer = true;
        const status: string = this.currentKey.status;
        return this.$store.dispatch("locations/qrCodeVerification", {
            token,
            keyId: this.currentKey?.id,
            keyStatus: status,
            estimatedEndDate: this.estimatedEndDate,
            dropFromRelay: this.droppingAction,
            giveToUserId: this.selectedGuest?.id,
            moveAllSubObjects: params?.moveAllSubObjects,
            referentId: this.currentUser.id,
            notificationType: this.notificationType,
        }).then(async (res: any) => {
            this.handToHandDialog = false;
            if (res.dropped || res.withdrawn) {
                this.successCallback(res);
            } else if (res.validLocation) {
                if (this.droppingAction) {
                    await this.dropKey();
                } else {
                    this.displayQrCodeReader = false;
                    this.displayPinPad = true;
                    this.relayId = res.relayId;
                }
            } else {
                this.qrCodeReaderError = this.$i18n.t("alerts.error." + res.errorMessage || "default");
            }
        }).catch((err) => {
            this.qrCodeReaderError = this.$i18n.t(`alerts.error.${err?.response?.data?.error || "qrCodeNotFound"}`);
        }).finally(() => {
            this.loadingQrCodeStreamer = false;
        });
    }

    private beforeDestroy() {
        this.resetQrCodeReader();
    }

    private async withdrawKey(referent: any): Promise<void> {
        this.loadingWithdrawQuery = true;
        await this.$store.dispatch("keys/withdraw", {
            keyId: this.currentKey.id,
            token: this.token,
            referentId: referent.id,
            keyToGuest: this.selectedGuest.id,
            estimatedEndDate: this.estimatedEndDate,
            notificationType: this.notificationType,
        })
            .then((res: any) => this.successCallback(res))
            .catch((err) => this.failureCallback(err))
            .finally(() => { this.loadingWithdrawQuery = false; });
    }

    private successCallback(res: any): void {
        if (res.keysNotMoved?.length > 0) {
            this.$store.commit("alerts/displayWarning", {
                msg: `${this.$i18n?.t("alerts.error.cannotMoveObject", {
                    objects: res.keysNotMoved.map((el) => el.name).join(", "),
                })}`,
            });
        } else if (this.droppingAction) {
            this.$store.commit("alerts/displaySuccess", {
                icon: "icon-picto_depot-agence",
                msg: this.$i18n?.t("alerts.key.dropSuccess", {
                    key: this.currentKey?.name,
                    relay: this.relay?.name,
                }),
            });
        } else {
            this.$store.commit("alerts/displaySuccess", {
                icon: "icon-picto_retrait-agence",
                msg: this.$i18n?.t("alerts.key.giveSuccess", {
                    key: this.currentKey?.name,
                    user: this.selectedGuest?.displayName,
                }),
            });
        }
        this.dropKeyDone();
    }

    private failureCallback(error?: any): void {
        this.$store.commit("alerts/displayHttpError", {
          error,
          icon: "icon-picto_retrait-agence",
        });
        this.dropKeyDone();
    }

    private async dropKey(): Promise<void> {
        await this.$store.dispatch("keys/drop", {
            keyId: this.currentKey.id,
            token: this.token,
            referentId: this.currentUser.id,
            relayId: this.relay.id,
            holderId: this.currentKey.KeyHolding[0]?.userId,
            keyToGuest: this.currentKey.KeyHolding[0]?.userId,
        })
            .then((res: any) => this.successCallback(res))
            .catch(() => this.failureCallback());
    }

    private dropKeyDone() {
        this.$store.dispatch("context/clearContext");
        this.$emit("reset");
        this.closeDialog();
    }
}
